
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(2),
  playerId: Number,
  conTime: Number.withConstraint(x => x >= 0),
  roundTime: Number.withConstraint(x => x >= 0),
  downloadrate: Number.withConstraint(x => x >= 0),
  bluebox: Number.withConstraint(x => x >= 0 && x <= 1),
  delay: Number.withConstraint(x => x >= 0),
  clientTimeZone: Number.withConstraint(x => x >= 0 && x <= 100),
  accountHash: String,
  event_mapping_version: Literal(2),
}).And(Partial({
  client_timestamp: Number.withConstraint(x => x >= 0),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  referrer: String.withConstraint(x => x.length <= 100),
  partner_id: Number.withConstraint(x => x >= 0),
  creative_id: Number.withConstraint(x => x >= 0),
  placement: String.withConstraint(x => x.length <= 255),
  keyword: String.withConstraint(x => x.length <= 255),
  network: String.withConstraint(x => x.length <= 1),
  landing_page: Number.withConstraint(x => x >= 0),
  channel_id: String.withConstraint(x => x.length <= 255),
  traffic_source_id: String.withConstraint(x => x.length <= 255),
  campaign_key: Number.withConstraint(x => x >= 0),
  adgroup_key: Number.withConstraint(x => x >= 0),
  advertiser_id: Number.withConstraint(x => x >= 0),
  match_type: String.withConstraint(x => x.length <= 1),
  is_ip_v6: Number.withConstraint(x => x >= 0 && x <= 1),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(2),
  playerId: Number,
  conTime: Number.withConstraint(x => x >= 0),
  roundTime: Number.withConstraint(x => x >= 0),
  downloadrate: Number.withConstraint(x => x >= 0),
  bluebox: Number.withConstraint(x => x >= 0 && x <= 1),
  delay: Number.withConstraint(x => x >= 0),
  clientTimeZone: Number.withConstraint(x => x >= 0 && x <= 100),
  accountHash: String,
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  lang: String.withConstraint(x => x.length <= 5),
}).And(Partial({
  client_timestamp: Number.withConstraint(x => x >= 0),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  referrer: String.withConstraint(x => x.length <= 100),
  partner_id: Number.withConstraint(x => x >= 0),
  creative_id: Number.withConstraint(x => x >= 0),
  placement: String.withConstraint(x => x.length <= 255),
  keyword: String.withConstraint(x => x.length <= 255),
  network: String.withConstraint(x => x.length <= 1),
  landing_page: Number.withConstraint(x => x >= 0),
  channel_id: String.withConstraint(x => x.length <= 255),
  traffic_source_id: String.withConstraint(x => x.length <= 255),
  campaign_key: Number.withConstraint(x => x >= 0),
  adgroup_key: Number.withConstraint(x => x >= 0),
  advertiser_id: Number.withConstraint(x => x >= 0),
  match_type: String.withConstraint(x => x.length <= 1),
  is_ip_v6: Number.withConstraint(x => x >= 0 && x <= 1),
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 2;
  